<div class="row">
  <div class="col-12">
    <div class="header">
      <p>{{ 'Prompts.PageIntro' | localize }}</p>
    </div>

    <mat-card class="cardWithShadow">
      <mat-card-content>
        <div class="d-flex justify-content-end mb-3">
          <button mat-raised-button color="primary" [routerLink]="['/apps/prompt-management/create']" [queryParams]="{organisationComponent: organisationComponent, selectedOrganisationId: selectedOrganisationId}">
            <mat-icon>add</mat-icon> {{ 'Prompts.NewPrompt' | localize }}
          </button>
        </div>

            <div class="p-3">
              <div *ngIf="loading" class="d-flex justify-content-center my-4">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="ms-3 pt-2">{{ 'Prompts.Loading' | localize }}</p>
              </div>

              <div *ngIf="!loading" class="table-responsive">
                <table mat-table [dataSource]="prompts" class="w-100">
                  <!-- ID Sütunu -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('id') | localize }}</th>
                    <td mat-cell *matCellDef="let prompt">{{ prompt.id }}</td>
                  </ng-container>

                  <!-- Prompt Text Sütunu -->
                  <ng-container matColumnDef="promptName">
                    <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('promptName') | localize }}</th>
                    <td mat-cell *matCellDef="let prompt">{{ prompt.promptName || 'İsimsiz Prompt' }}</td>
                  </ng-container>

                  <!-- Prompt Tipi Sütunu -->
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('type') | localize }}</th>
                    <td mat-cell *matCellDef="let prompt">
                      <mat-chip [ngClass]="{
                        'mat-primary': prompt.type === 'DOCUMENT_PARSER',
                        'mat-accent': prompt.type === 'MULTIMEDIA_ANALYZER',
                        'mat-warn': prompt.type === 'WEB_SERVICES' || prompt.type === 'INTEGRATION'
                      }">
                        {{ getTypeDisplay(prompt.type) | localize }}
                      </mat-chip>
                    </td>
                  </ng-container>

                  <!-- İşlemler Sütunu -->
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader('actions') | localize }}</th>
                    <td mat-cell *matCellDef="let prompt">
                      <!-- Sadece doğrudan butonları göster -->
                      <button mat-icon-button color="info" [matTooltip]="localizationService.getLocalizationValue('Prompts.Actionss.View')"
                              [routerLink]="['/apps/prompt-management/create', {id: prompt.id, mode: 'view'}]"
                              [queryParams]="{organisationComponent: organisationComponent, selectedOrganisationId: selectedOrganisationId}"
                              class="mobile-hidden">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button mat-icon-button color="primary" [matTooltip]="localizationService.getLocalizationValue('Prompts.Actionss.Edit')"
                              [routerLink]="['/apps/prompt-management/create', {id: prompt.id, mode: 'edit'}]"
                              [queryParams]="{organisationComponent: organisationComponent, selectedOrganisationId: selectedOrganisationId}"
                              class="mobile-hidden">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button *ngIf="this.permissionService.hasPermission('PROMPT_MANAGEMENT_DELETE')" mat-icon-button color="warn" [matTooltip]="localizationService.getLocalizationValue('Prompts.Actionss.Delete')" (click)="deletePrompt(prompt)"
                              class="mobile-hidden">
                        <mat-icon>delete</mat-icon>
                      </button>

                      <!-- Mobil için 3 noktalı menü -->
                      <button mat-icon-button color="primary" [matMenuTriggerFor]="mobileMenu"
                              class="mobile-visible">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #mobileMenu="matMenu">
                        <button mat-menu-item [routerLink]="['/apps/prompt-management/create', {id: prompt.id, mode: 'view'}]"
                                [queryParams]="{organisationComponent: organisationComponent, selectedOrganisationId: selectedOrganisationId}">
                          <mat-icon color="info">visibility</mat-icon>
                          <span>{{ 'Prompts.Actionss.View' | localize }}</span>
                        </button>
                        <button mat-menu-item [routerLink]="['/apps/prompt-management/create', {id: prompt.id, mode: 'edit'}]"
                                [queryParams]="{organisationComponent: organisationComponent, selectedOrganisationId: selectedOrganisationId}">
                          <mat-icon color="primary">edit</mat-icon>
                          <span>{{ 'Prompts.Actionss.Edit' | localize }}</span>
                        </button>
                        <button mat-menu-item (click)="deletePrompt(prompt)" *ngIf="this.permissionService.hasPermission('PROMPT_MANAGEMENT_DELETE')">
                          <mat-icon color="warn">delete</mat-icon>
                          <span>{{ 'Prompts.Actionss.Delete' | localize }}</span>
                        </button>
                      </mat-menu>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <!-- Veri yoksa -->
                <div *ngIf="prompts.length === 0" class="text-center py-4">
                  <mat-icon class=" d-block mx-auto my-3" style="font-size: 48px; width: 48px; height: 48px;">info</mat-icon>
                  <p>{{ 'Prompts.NoPrompts' | localize }}</p>
                </div>
              </div>
            </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
